export default __webpack_public_path__ + "static/media/tvs_Ntorq_rt_fi_catalogo.571909ee.pdf";